import React from 'react';
import './Wheel.scss';

interface SGWheelProps {
    offset: number;
    id: string;
    dasharray: number;
    wheelColor: string;
    wheelColorLabel: string;
    wheelColorBackground: string;
    remainingCredits: string;
    show: string;
}

const CSS_CLASS = {
    container: 'wheel__container',
    number: 'wheel__number',
    mask: 'wheel__mask',
    stroke: 'wheel-stroke',
};

export const Wheel = (props: SGWheelProps) => {
    return (
        <div style={{backgroundColor: props.wheelColorBackground}} className={CSS_CLASS.container} key={props.id}>
            <div
                className={`${CSS_CLASS.mask} ${CSS_CLASS.mask}--${props.wheelColorLabel}`}
                style={{ display: props.show }}
            >
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <circle
                        style={{
                            strokeDasharray: props.dasharray,
                            strokeDashoffset: props.dasharray - props.offset,
                            stroke: props.wheelColor,
                        }}
                        className={`${CSS_CLASS.stroke} grow-${props.offset}`}
                        cx="20"
                        cy="20"
                        r="18"
                    />
                </svg>
            </div>
            <span className={`${CSS_CLASS.number}--${props.wheelColorLabel}`}>{props.remainingCredits}</span>
        </div>
    )
};
